import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import Sorting from '../../../components/common/sorting'
import Loader from '../../../components/company_panel/common/loader'
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, getBrandId, getOutletId, TrimText, checkPermission } from '../../../helpers/commonFunctions'
import CustomPagination from '../../../components/company_panel/common/custompagination'
import notFound from '../../../assets/company/img/no-record-found.png'
import Breadcrums from '../../../components/company_panel/common/breadcrumbs'
import { CreateInventoryEndOfDaysCount, GetInventoryEndOfDaysList } from '../../../services/company_panel/inventoryService'
import { LOADER_TIME } from '../../../utils/Constants'
import Swal from 'sweetalert2'
import { DetailsLoyaltyPoint } from '../../../services/company_panel/loyaltypoints.service'
import logo from '../../../../src/assets/company/img/logo.png';


// what the field accepts while typing, and what counts as a finished value
const PHYSICAL_COUNT_TYPING = /^\d{0,8}(\.\d{0,2})?$/;
const PHYSICAL_COUNT_VALID = /^\d{1,8}(\.\d{1,2})?$/;

const MonthlyList = () => {

    const breadcrumbs = [
        {
            title: "Inventory",
            url: "/company/raw_materials/inventory/list/1"
        },
        {
            title: "End Of Day Histories",
            url: "/company/raw_materials/inventory/end_of_day/history/list/1"
        },
        {
            title: "Monthly",
            url: ""
        },
    ]
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false)

    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [physicalCounts,setPhysicalCounts] = useState({});
    const [physicalCountsInvalid, setPhysicalCountsInvalid] = useState({});

    const [businessDate,setBusinessDate] = useState([]);
    // const [businessDateOrdersCount, setBusinessDateOrdersCount] = useState(0);
    const [inventoryDate, setInventoryDate] = useState([]);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
    });

    // Inventory rows are brand-scoped, so switching outlet leaves the list — and
    // anything already typed into it — alone. Only the two dates below the
    // header belong to the outlet, so only those are refetched. per_page 1
    // because the rows that come back with them are not used here.
    const refreshOutletDates = () => {
        const formData = new FormData();
        formData.append("page", 1);
        formData.append("per_page", 1);
        formData.append('brand_id', getBrandId());
        formData.append('outlet_id', getOutletId());
        formData.append('duration', 'monthly');
        GetInventoryEndOfDaysList(formData).then(data => {
            const response = data?.data?.response;
            setBusinessDate(response?.business_date || null);
            setInventoryDate(response?.inventory_date || null);
        }).catch(error => {
            console.log("error ====> ", error);
        });
    };

    useEffect(() => {
        document.addEventListener('outlet-changed', refreshOutletDates);
        return () => document.removeEventListener('outlet-changed', refreshOutletDates);
    }, []);




    const isFetchingRef = useRef(false);
    const [loadingMore, setLoadingMore] = useState(false);

    const fetchPage = useCallback(async (pageNum) => {
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        if (pageNum === 1) setLoader(true); else setLoadingMore(true);
        try {
            const formData = new FormData();
            formData.append("page", pageNum);
            formData.append("per_page", itemPerPage);
            formData.append('brand_id', getBrandId());
            formData.append('outlet_id', getOutletId());
            formData.append('duration', 'monthly');
            const data = await GetInventoryEndOfDaysList(formData);
            const response = data?.data?.response;
            const rows = response?.rows || [];
            const total = response?.count || 0;
            setDataLength(total);
            if (pageNum === 1) {
                setBusinessDate(response?.business_date || null);
                setInventoryDate(response?.inventory_date || null);
                setList(rows);
            } else {
                setList(prev => [...prev, ...rows]);
            }
            setPhysicalCounts(prev => {
                const next = { ...prev };
                rows.forEach(inv => {
                    if (next[inv.id] === undefined) next[inv.id] = 0;
                });
                return next;
            });
            setPage(pageNum);
        } catch (error) {
            console.log("error ====> ", error);
        } finally {
            isFetchingRef.current = false;
            if (pageNum === 1) setTimeout(() => setLoader(false), LOADER_TIME);
            else setLoadingMore(false);
        }
    }, [itemPerPage]);

    useEffect(() => {
        setList([]);
        fetchPage(1);
    }, [isBrandChanged, location, statsUpdate, itemPerPage]);

    const handleTableScroll = (e) => {
        const el = e.currentTarget;
        if (el.scrollHeight - el.scrollTop - el.clientHeight < 100) {
            if (!isFetchingRef.current && list.length < dataLength) {
                fetchPage(page + 1);
            }
        }
    };

const handleInputChange = (inventoryId) => (event) => {
    const value = event.target.value;
    // physical_count is numeric(10,2): block anything that is not a plain
    // positive number so "3..9" or "-5" never reaches the API
    if (value !== '' && !PHYSICAL_COUNT_TYPING.test(value)) {
        return;
    }

    setPhysicalCountsInvalid((prev) => {
        const next = { ...prev };
        if (value === '' || PHYSICAL_COUNT_VALID.test(value)) {
            delete next[inventoryId];
        } else {
            next[inventoryId] = true;
        }
        return next;
    });

    setPhysicalCounts((prev) => ({
        ...prev,
        [inventoryId]: value,
    }));
};
const handleSubmit = () => {
    if (Object.keys(physicalCountsInvalid).length) return;

    const formData = new FormData();
    formData.append('brand_id', getBrandId());
    formData.append('outlet_id', getOutletId());
    formData.append('duration', 'monthly');
    formData.append('business_date', businessDate);
    const dataArray = [];
    for (const inventoryId in physicalCounts) {
        const value = physicalCounts[inventoryId];
        // untouched rows keep their numeric 0 default and are skipped, as before
        if (value && PHYSICAL_COUNT_VALID.test(String(value))) {
            dataArray.push({
                inventory_id: inventoryId,
                physical_count: Number(value)
            });
        }
    }
    formData.append('data', JSON.stringify(dataArray));
    CreateInventoryEndOfDaysCount(formData).then(response => {
        if (response.data.status === 1 || response.data.status === "1") {
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                position: 'top-right',
            });
            // setStatusUpdate(!statsUpdate);
            // Back to the history, where the count just submitted now shows up.
            // the history list needs view on end of inventories; without it, back to inventories
            navigate(checkPermission('store_end_of_inventories', 'view')
                ? `/company/raw_materials/inventory/end_of_day/history/list/1`
                : `/company/raw_materials/inventory/list/1`)
        } else {
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: response.data.message,
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }
    }).catch(error => {
        console.log("error ====> ", error);
         Swal.fire({
            customClass: 'swal-wide',
            icon: 'error',
            title: error?.response?.data?.errors?.message,
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top-right',
        });
    });
};

const handlePrint = () => {

    const formData = new FormData()
    formData.append("page", 1)
    formData.append("per_page", dataLength)
    formData.append('brand_id', getBrandId());
    formData.append('outlet_id', getOutletId());
    formData.append('duration', 'monthly');
    GetInventoryEndOfDaysList(formData).then(data => {
        setDataLength(data.data.response.count);
        const listData = data && data.data && data.data.response ? data.data.response.rows : [];
        const dateTime = new Date().toLocaleString();
        const printContent = `
         <div style="text-align: center;">
               <img src=${logo} alt="Logo" style="max-width: 200px; height: auto;"/>
                </div>
               <div style="text-align: right; margin-bottom: 20px;">
                   ${dateTime}
                 </div>
            <table className="table table-custom">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Category</th>
                        <th>Sub Category</th>
                        <th>Unit Per Measure</th>
                        <th>Physical Count</th>
                    </tr>
                </thead>
                <tbody>
                    ${listData.length ? listData.filter(row=> physicalCounts[row.id]).map((row, i) => `
                        <tr key="${i}">
                            <td>${capitalizeFirstLetter(TrimText(row.item_name, 30))}</td>
                            <td>${row?.category?.category?.name ? capitalizeFirstLetter(row.category.category.name) : "N/A"}</td>
                            <td>${row?.category?.name ? capitalizeFirstLetter(row.category.name) : "N/A"}</td>
                            <td>${capitalizeFirstLetter(row.inventory_unit_converisons.find(unit => unit.unit_type === "Count Unit")?.uomDetails.uom_code) || "N/A"}</td>
                            <td><input type="text" className="form-control" autoComplete='off' value='${physicalCounts[row.id]}' /></td>
                        </tr>
                    `).join('') : `
                        <tr>
                            <td colspan="5" class="text-center">No Record</td>
                        </tr>
                    `}
                </tbody>
            </table>
        `;

        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
            <html>
                <head>
                    <title></title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        th, td {
                            border: 1px solid #000;
                            padding: 8px;
                            text-align: left;
                        }
                        th {
                            background-color: #f2f2f2;
                        }
                        tr:nth-child(even) {
                            background-color: #f9f9f9;
                        }
                                @media print {
    @page {
        margin: 0; /* Remove default margins */
    }
    body {
        -webkit-print-color-adjust: exact; /* Ensure color is preserved */
    }
    header, footer, nav {
        display: none; /* Hide headers, footers, and navigation */
    }
}
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
            </html>
        `);
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
    }).catch(error => {
        console.log("Error fetching data for print:", error);
    });
};

const isSubmitDisabled = () => {
    const isDisabled =  !businessDate ||
        Object.keys(physicalCountsInvalid).length > 0 ||
        // !businessDateOrdersCount ||
        Object.values(physicalCounts).every(count => {
            const numCount = parseFloat(count);
            return count === '' ||
                isNaN(numCount) ||
                numCount < 0;
                // (numCount === 0 && count.includes('-')) ||
                // count.length > 8
        });
    return isDisabled;
};

    return (
        <>
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Inventory</h4>
                        <Breadcrums data={breadcrumbs} />
                    </div>
                    <div className='page-header-right ms-auto'>
                    <button className="btn btn-primary ms-2" onClick={handlePrint} disabled={dataLength === 0} >Print Count Template</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                    <div className="date-display mb-2 d-flex justify-content-right ms-3">
                            <div className="d-flex flex-column align-items-start me-4">
                                <span>Date Of Business</span>
                                <span className="date-value fw-bold">{businessDate !== null  ? formateDate(businessDate) : '-'}</span>
                            </div>
                            <div className="d-flex flex-column align-items-start me-4 ms-3">
                                <span>Date Of System</span>
                                <span className="date-value fw-bold">{formateDate(new Date())}</span>
                            </div>
                            <div className="d-flex flex-column align-items-start ms-3">
                                <span>Date Of Inventory</span>
                                <span className="date-value fw-bold">{inventoryDate !== null  ? formateDate(inventoryDate) : '-'}</span>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center mt-4'>
                            <ul className="d-flex setting w-100 mb-0 p-0">
                                <li className="ms-3"><Link to={`/company/raw_materials/inventory/end_of_day/daily/list/${1}`} className="btn">Daily</Link></li>
                                <li className="ms-3"><Link to={`/company/raw_materials/inventory/end_of_day/weekly/list/${1}`} className="btn">Weekly</Link></li>
                                <li className="ms-3"><Link to={`/company/raw_materials/inventory/end_of_day/bi_weekly/list/${1}`} className="btn">Bi Weekly</Link></li>
                                <li className="ms-3 active"><Link to={`/company/raw_materials/inventory/end_of_day/monthly/list/${1}`} className="btn btn-primary">Monthly</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className='gap-20'>
                    </div>
                    <div className="table-wrap">
                        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }} onScroll={handleTableScroll}>
                        <div id="printableArea">
                                <table className="table table-custom">
                                    <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                                        <tr>
                                            <th>Name</th>
                                            <th>Category</th>
                                            <th>Sub Category</th>
                                            <th>Unit Per Measure</th>
                                            <th>Physical Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ? (
                                            <tr>
                                                <td colSpan={5}><Loader /></td>
                                            </tr>
                                        ) : (
                                            list.length ? list.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{capitalizeFirstLetter(TrimText(row.item_name, 30))}</td>
                                                    <td>{row?.category?.category?.name ? capitalizeFirstLetter(row.category.category.name) : "N/A"}</td>
                                                    <td>{row?.category?.name ? capitalizeFirstLetter(row.category.name) : "N/A"}</td>
                                                    <td>{capitalizeFirstLetter(row.inventory_unit_converisons.find(unit => unit.unit_type === "Count Unit")?.uomDetails.uom_code) || "N/A"}
                                                    </td>
                                                    <td>
                                                        <input type="text" className={`form-control ${physicalCountsInvalid[row.id] ? 'is-invalid' : ''}`}
                                                            placeholder='Please Enter'
                                                            autoComplete='off'
                                                            inputMode='decimal'
                                                            onChange={handleInputChange(row.id)}
                                                            value={physicalCounts[row.id] === undefined ? '' : physicalCounts[row.id]}
                                                        />
                                                        {
                                                            physicalCountsInvalid[row.id]
                                                            ? <span className='text-danger'>Enter a number with up to 2 decimals</span>
                                                            : null
                                                        }
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">
                                                        <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                        <p>No Record</p>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                        {loadingMore && (
                                            <tr>
                                                <td colSpan={5} className="text-center"><Loader /></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='tabler-footer' style={{ position: 'sticky', bottom: 0, background: '#fff', borderTop: '1px solid #e7e7e7', padding: '10px 16px', zIndex: 2 }}>
                            <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                                <div className='d-flex align-items-center gap-2'>
                                    <label className='mb-0'>Page size</label>
                                    <select
                                        className='form-control form-control-sm'
                                        style={{ width: 'auto' }}
                                        value={itemPerPage}
                                        onChange={(e) => setItemPerPage(Number(e.target.value))}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span className='ms-3'><b>Total Records: {dataLength || 0}</b></span>
                                </div>
                                <button className="btn btn-primary btn-submit" type="button" onClick={handleSubmit} disabled={isSubmitDisabled()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MonthlyList
